import gql from 'graphql-tag';

export const NOTIFICATIONS = gql`
	query Notifications($input: NotificationsInput) {
		customer {
			id
			notifications(input: $input) {
				notifications {
					id
					type
					date
					message
					isRead
					projectId
					referenceId
					projectName
				}
				totalPages
			}
			unreadNotificationCount
		}
	}
`;

export const UNREAD_NOTIFICATION_COUNT = gql`
	query UnreadNotificationCount($input: UnreadNotificationsInput) {
		customer {
			id
			unreadNotificationCount(input: $input)
		}
	}
`;

export const MARK_ALL_NOTIFICATIONS_READ = gql`
	mutation MarkAllNotificationsRead {
		markAllNotificationsRead
	}
`;
